export default __webpack_public_path__ + "static/media/bell-active.9807a677.svg";